import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { setPassword } from '../../services/apiService';
import Button, { ButtonType } from '../general-components/Button';
import styles from './ResetPassword.module.css';
import FormInput from '../general-components/FormInput';
import {
    passwordValidate,
    repeatPasswordValidate,
} from '../../services/formValidationService';
import SignupLayout from '../ui-components/SignupLayout';

const ResetPassword: React.FC = () => {
    const { t } = useTranslation();
    const [password, setCurrPassword] = useState<string>('');
    const [repeat, setRepeat] = useState<string>('');
    const [error, setError] = useState<string>('');
    const [showConfirm, setShowConfirm] = useState(false);

    let { id } = useParams<{ id: string }>();

    const setNewPassword = () => {
        const pw = passwordValidate(password);
        const rpw = repeatPasswordValidate(password, repeat);
        if (!pw.valid) {
            setError(pw.message);
        } else if (!rpw.valid) {
            setError(rpw.message);
        } else {
            setPassword(password, id);
            setShowConfirm(true);
        }
    };

    return (
        <SignupLayout>
            {showConfirm && (
                <React.Fragment>
                    <div className={styles.info}>
                        <h3>
                            {t('passwordReset.resetPassword.confirm.title')}
                        </h3>
                    </div>
                    <form className={styles['login-form']}>
                        <Button
                            className={styles.button}
                            type={ButtonType.primary}
                            onClick={() => {
                                window.location.href = '/login';
                            }}
                        >
                            {t(
                                'passwordReset.resetPassword.confirm.buttons.returnToLogin'
                            )}
                        </Button>
                    </form>
                </React.Fragment>
            )}
            {!showConfirm && (
                <div className={styles.wrapper}>
                    <div className={styles.info}>
                        <h3>{t('passwordReset.resetPassword.reset.title')}</h3>
                        <p>{t('passwordReset.resetPassword.reset.message')}</p>
                    </div>
                    <form className={styles.form}>
                        <FormInput
                            label={t(
                                'passwordReset.resetPassword.reset.form.password'
                            )}
                            placeholder={t(
                                'passwordReset.resetPassword.reset.form.placeholder'
                            )}
                            onChange={({ target }) => {
                                setCurrPassword(
                                    (target as HTMLInputElement).value
                                );
                            }}
                            type="password"
                            errorMsg={error}
                        />
                        <FormInput
                            label={t(
                                'passwordReset.resetPassword.reset.form.repeatPassword'
                            )}
                            placeholder={t(
                                'passwordReset.resetPassword.reset.form.placeholder'
                            )}
                            onChange={({ target }) => {
                                setRepeat((target as HTMLInputElement).value);
                            }}
                            type="password"
                            errorMsg={error}
                        />
                        <Button
                            className={styles.button}
                            type={ButtonType.submit}
                            onClick={() => setNewPassword()}
                        >
                            {t(
                                'passwordReset.resetPassword.reset.form.buttons.setNewPassword'
                            )}
                        </Button>
                    </form>
                </div>
            )}
        </SignupLayout>
    );
};

export default ResetPassword;
